// extracted by mini-css-extract-plugin
export default {"stats":"AlgoliaStats-stats-ObF"};